import React from "react";
import { Form, Table } from "react-bootstrap";

import RenderAmount from "../../../Components/etc/RenderAmount";
import { getFullName } from "../../../Modules/utils/fullname";

class AgentReceiptGrouped extends React.PureComponent {
  commissionColumns = [
    {
      value: "monthDiff",
      label: "Month",
      render: ({ item }) => (
        <div className="numeric">
          {item.accountType === "loan" ? "Loan" : item.monthDiff}
        </div>
      ),
    },
    {
      value: "trAmount",
      label: "Deposit",
      render: ({ item }) => <RenderAmount value={item?.trAmount} />,
    },

    {
      value: "commissionRate",
      label: "Interest",
      render: ({ item }) =>
        item.commissionRate ? (
          <div className="numeric">{item.commissionRate}%</div>
        ) : (
          ""
        ),
    },
    {
      value: "amount",
      label: "Commission",
      render: ({ item }) => <RenderAmount value={item.commissionAmount} />,
    },
  ];

  renderDetails() {
    const { data } = this.props;
    if (!data) return;

    const { agent } = data;

    return (
      <div style={{ flex: 1, margin: "0 1rem" }}>
        <Table bordered size="sm" className="vertical-table">
          <tbody>
            <tr>
              <th>Name</th>
              <td style={{fontWeight: '600'}}>{getFullName(agent)}</td>
            </tr>
            <tr>
              <th>Receipt Date</th>
              <td>{new Date().toLocaleString()}</td>
            </tr>

            <tr>
              <th>email</th>
              <td>{agent.email}</td>
            </tr>
            <tr>
              <th>Address</th>
              <td className="multiline">{agent.address}</td>
            </tr>
            {/* <tr>
              <th>Total Commission</th>
              <td>
                <RenderAmount value={this.props.data?.totalCommission} />
              </td>
            </tr> */}
          </tbody>
        </Table>
      </div>
    );
  }

  render() {
    const { data } = this.props;
    if (!data) return;

    const { commissions, range, total } = data;

    console.log(data)

    return (
      <div className="m-1 agentreceipt" style={{ minWidth: "20rem", fontSize: "0.95rem", paddingTop: '0.5rem' }}>
        <center>
          <h5 style={{}}>TN Dhing</h5>
        </center>
        <center>
          <span style={{ textDecoration: "underline" }}>Collector Receipt</span>
        </center>

        <div style={{ textAlign: "right", marginRight: "1rem" }}>
          {new Date(range?.[0]).toLocaleDateString()} -{" "}
          {new Date(new Date(range?.[1]).getTime() - 1).toLocaleDateString()}
        </div>

        {this.renderDetails()}

        <div style={{ flex: 1, margin: "0 1rem" }}>
          <Form.Label>Commissions: </Form.Label>

          <div className="tablewrapper" style={{ fontSize: "0.85rem" }}>
            <Table className="itemstable" bordered>
              <tbody>
                <tr>
                  {this.commissionColumns?.map((x) => (
                    <th key={x.value}>{x.label}</th>
                  ))}
                </tr>
                {commissions?.map((item, index) => (
                  <tr key={item._id}>
                    {this.commissionColumns?.map((col) => {
                      return (
                        <td key={col.value}>
                          {col.render
                            ? col.render({ item, index })
                            : item[col.value]}
                        </td>
                      );
                    })}
                  </tr>
                ))}

                <tr key={'total'} style={{ color: 'blue', fontWeight: '500' }}>
                  <td>
                    Total
                  </td>
                  <td><RenderAmount value={total?.transction?.amount}/></td>
                  <td></td>
                  <td><RenderAmount value={total?.amount}/></td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

export default AgentReceiptGrouped;
